import React from 'react';
import ReportPageShell from './ReportPageShell';
import { REPORT_DOCUMENT_TYPES } from '../../utils/reportDocumentTypes';

export default function TransferCertificatePage() {
  return <ReportPageShell documentType={REPORT_DOCUMENT_TYPES.TC} />;
}
